module.exports = __webpack_public_path__ + "static/img/morehema.f5b51cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/morehema.png
// module id = B11L
// module chunks = 1